import { useEffect, useState } from "react";

import API_URL from "../apiConfig";

import "../CSS/freiezeiten.css";


function FreieZeitenPage() {

    const [appointments, setAppointments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");


    // ==================================================
    // TERMINE VON DER PHP-API LADEN
    // ==================================================

    useEffect(() => {

        fetch(
            `${API_URL}/appointments.php`
        )

            .then((response) => {

                if (!response.ok) {

                    throw new Error(
                        "Termine konnten nicht geladen werden."
                    );
                }

                return response.json();
            })

            .then((daten) => {

                setAppointments(daten);
                setIsLoading(false);
            })

            .catch((fehler) => {

                setError(fehler.message);
                setIsLoading(false);
            });

    }, []);


    // ==================================================
    // AUSGABE
    // ==================================================

    return (

        <>

            <div className="intro">

                <h1>
                    Freie Zeiten
                </h1>

                <p>
                    Hier kannst Du sehen, zu welchen Terminen
                    ich Dich empfangen kann.
                </p>

            </div>


            <main className="freiezeiten-main">

                <section className="termine">

                    <p>
                        Termine bitte immer 24h im Voraus per
                        WhatsApp anfragen und bestätigen lassen.
                    </p>


                    <p>
                        Bei kurzfristigen Anfragen kann es sein,
                        dass ich nicht rechtzeitig reagieren kann.
                    </p>


                    <h2>
                        Freie Massagezeiten an folgenden Tagen:
                    </h2>


                    {
                        isLoading && (

                            <p>
                                Termine werden geladen...
                            </p>

                        )
                    }


                    {
                        error && (

                            <p>
                                {error}
                            </p>

                        )
                    }


                    {
                        !isLoading &&
                        !error &&
                        appointments.length === 0 && (

                            <p>
                                Zurzeit sind keine freien Termine verfügbar.
                                Weitere Termine werden laufend aufgeschaltet.
                                Du kannst aber spontan anfragen und den Wunschtermin nennen evt lässt sich was machen.
                            </p>

                        )
                    }


                    {
                        !isLoading &&
                        !error &&
                        appointments.length > 0 && (

                            <table className="termin-tabelle">

                                <thead>

                                    <tr>
                                        <th>Datum</th>
                                        <th>Tag</th>
                                        <th>Zeit</th>
                                        <th>Status</th>
                                    </tr>

                                </thead>


                                <tbody>

                                    {
                                        appointments.map(
                                            (appointment) => (

                                                <tr
                                                    key={
                                                        appointment.id
                                                    }
                                                >

                                                    <td>
                                                        {
                                                            appointment.datum
                                                        }
                                                    </td>

                                                    <td>
                                                        {
                                                            appointment.tag
                                                        }
                                                    </td>

                                                    <td>
                                                        {
                                                            appointment.zeit
                                                        }
                                                    </td>

                                                    <td
                                                        className={
                                                            appointment.status === "Frei"
                                                                ? "frei"
                                                                : "vergeben"
                                                        }
                                                    >
                                                        {
                                                            appointment.status
                                                        }
                                                    </td>

                                                </tr>

                                            )
                                        )
                                    }

                                </tbody>

                            </table>

                        )
                    }

                </section>

            </main>

        </>
    );
}


export default FreieZeitenPage;